document.addEventListener("DOMContentLoaded", function () {
  // de 站点重定向
  if (window.location.href === "https://doogee-au.myshopify.com/") {
      // 重定向到新 URL
      window.location.href = "https://www.doogee.com.au/";
  }
});